import { render, staticRenderFns } from "./LineManVehicleBound.vue?vue&type=template&id=20910ad4&scoped=true"
import script from "./LineManVehicleBound.vue?vue&type=script&lang=js"
export * from "./LineManVehicleBound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20910ad4",
  null
  
)

export default component.exports